// Main analytics API
export {
	trackPageView,
	trackComponent,
	trackComponentLoad,
	firePageLoadEvent,
} from "./analytics";

// Core functions (for advanced usage)
export {
	FULLY_LOADED,
	buildDataLayerObject,
	composeCleverTapPayload,
	composeDataLayerProps,
	deriveGaEventType,
	dispatchAnalyticsEvent,
	markViewEventTriggered,
	toErrorMessage,
} from "./functions";

// Mappers
export { mapCleverTapToGA } from "./mappers";

// Page load tracking
export {
	initPageLoadRequestTracking,
	trackPageLoadAsyncWork,
	waitForPageLoadRequestsToSettle,
} from "./trackPageLoadRequests";
export type { PageLoadRequestsSettledResult } from "./trackPageLoadRequests";

// State management (for app-layer sync)
export {
	setAnalyticsLoginStatus,
	setAnalyticsTokenPresent,
	getLoginStatus,
	getIsTokenPresent,
} from "./state/loginState";

export {
	getActivityTimeLogState,
	setActivityTimeLogState,
} from "./state/activityTimeLog";

// Types
export type {
	GaEventType,
	CleverTapPayload,
	GoogleAnalyticsValue,
	GoogleAnalyticsPayload,
	DataLayerProps,
	DataLayerState,
	ComponentEventInput,
	PageViewInput,
	GaMappingParams,
	DispatchContext,
} from "./types";

// React hooks (for Next.js app integration)
export { useAnalyticsAuthSync } from "./hooks/useAnalyticsAuthSync";
